<template>
  <div class="panel-body" :style="height">
    <div class="row">
      <table :id="id" class="table">
        <thead>
          <tr class="text-center">
            <th v-for="(val, key, index) in names" :id="id + '-name-' + key" :key="key">
              {{ val.name }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(row, key, index) in data" :id="'body-' + key" :key="key" :class="tbClass">
          <tr class="info" @click="toggleTD(row.estacion + '-' + key, key)">
            <td v-for="(r, k, i) in row" :id="id + '-body-' + k" :key="k" v-show="k !== 'bitArr' && k !== 'estacion'">
              <p> {{ r }} </p>
            </td>
          </tr>
          <tr>
            <td id="colspan" :id="row.estacion + '-' + key" class="hidden" colspan="15">
              <div class="container-fluid sub-table">
                <div class="row">
                  <div class="col-md-4" style="margin: 0; padding: 0;">
                    <table id="bits" class="table">
                      <thead>
                        <tr>
                          <td colspan="2">Bits</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="text-center" v-for="(ba, k, i) in row.bitArr" :key="k">
                          <td>{{ba.name}}</td>
                          <td>
                            <div class="span_switch red" v-if="ba.val !== 0"> {{ba.val}} </div>
                            <div class="span_switch green" v-else> </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-4">
                    <table id="bits" class="table">
                      <thead>
                        <tr>
                          <td>Indicaciones</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p class="text-center">Batería</p>
                            <div class="bar" :id="`${row.estacion}${key}Bar`"></div>
                            <img class="indicator" :src="imgUrl('campo_params.png')">
                            <br><br><br>
                            <p class="text-center">USB</p>
                            <div class="bar" :id="`${row.estacion}${key}Ubs`"></div>
                            <img class="indicator" :src="imgUrl('campo_params.png')">
                            <br><br><br>
                            <p class="text-center">Antena</p>
                            <div class="bar" :id="`${row.estacion}${key}Ubs`"></div>
                            <img class="indicator" :src="imgUrl('campo_params.png')">
                            <br><br><br>
                            <p class="text-center">RAM</p>
                            <div class="bar" :id="`${row.estacion}${key}Ubs`"></div>
                            <img class="indicator" :src="imgUrl('campo_params.png')">
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                  <div class="col-md-4">
                    <table id="bits" class="table">
                      <thead>
                        <tr>
                          <td>Graficas</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td id="line-chart">
                            <select-c name="tipo" id="tipo" :options="opts" placeholder="Tipo de Tabla" @changeSelect="chooseTipo('LOAD_BATERIA', key)"></select-c>
                            <line-chart :id="`${key}-chart`" :height="200" ref="chart" :chart-data="datacollection" :options="chartOps"></line-chart>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  <button id="loading-btnData" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
  <modal name="loading-modal" cclass="transparent">
    <loading-modal :info="{ modalName: 'loading-modal' }"></loading-modal>
  </modal>
  </div>
</template>

<script>
var $ = require('jquery')
import selectC from 'reusable/Select'
import LineChart from 'components/Charts/LineChart.js'
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')
import toastr from 'toastr'

/*
NAMES:
alarmFields: {
        'f1': {  // data with icon
          name: 'Fecha',
          icon: 'fa-angle-down'
        },
        'f2': { // just a name
          name: 'Concepto',
        }
      },
*/

/**
 *  DATA
 bitacora: [
        {
          id: 1,
          fecha: '10/07/2017',
          concepto: 'toluca-df',
          ducto: 23,
          usuario: 320,
          comentario: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis placeat sit, praesentium harum laborum dolorem minus quo aliquam fugit dolore dolorum facere adipisci repellendus dolores in omnis recusandae quasi impedit?',
          alarmaAsignada: {  <-- este nombre no es forzoso
            iconOnly: false,    <-- todos los nombres dentro del objeto son forzosos
            status: true,
            text: 'No Alarma',
            icon: 'warning',
            istyle: 'color: red; display: block',
            pstyle: ''
          }
        },
        {
          id: 2,
          fecha: '10/07/2017',
          concepto: 'mexicali-tijuana',
          ducto: 45,
          usuario: 250,
          comentario: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis placeat sit, praesentium harum laborum dolorem minus quo aliquam fugit dolore dolorum facere adipisci repellendus dolores in omnis recusandae quasi impedit?',

        },
      ]
 */

export default {
  props: ['data', 'names', 'id', 'modalTarget', 'height', 'tbClass'],
  data() {
    return {
      colspan: 0,
      status: false,
      opts: [
        {
          name: 'Bateria',
          value: 'bateria'
        },
        {
          name: 'USB',
          value: 'usb'
        },
        {
          name: 'Antena',
          value: 'antena'
        },
        {
          name: 'RAM',
          value: 'ram'
        },
      ],
      datacollection: {
        datasets: []
      },
      chartOps: {
         legend: {
                display: false
              },
        responsive: false,
        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            time: {
              unit: 'hour',
              displayFormats: {
                day: 'MMM D',
                hour: 'DD MMM,	HH:mm',
              },
              min: (new Date()).setHours('00', '00', '00', '00'),
              max: (new Date()).setHours('24', '00', '00', '00'),
              stepSize: 2
            },
          }],
          yAxes: [{
            ticks: {
              min: 10,
              max: 16,
              stepSize: 1,
            }
          }]
        }
      },
    }
  },
  methods: {
    formatDate(){
        // let date = new Date().toLocaleString('es-US', {
        //   hour12: false
        // }).split(' ')
        let date = new Date(new Date().setHours(0, 0, 0, 0)).toLocaleString('es-US', { hour12: false })
        date = date.split(' ')
        let time = date[1]
        let mdy = date[0].split('/')
        let month = parseInt(mdy[0])
        let day = parseInt(mdy[1])
        let year = parseInt(mdy[2])
        return `${year}-${day}-${month} ${time}`
    },
    chooseTipo(e, id){
      this.loading()
      let desde = this.formatDate()
      let hasta = desde.split(' ')
      hasta = `${hasta[0]} 23:59:59`

      this.$store.dispatch('LOAD_BATERIA', {
          ducto: document.querySelector('#ducto-campo').value,
          estacion: '',
          desde,
          hasta
        })
      .then(resp => {
        this.loading()
        let temp = []
        let response = resp.data.filter(rd => {
          return rd.rtu_name === this.data[id].site
        })
        if(response.length === 0){
          toastr.error('No se encontró información')
          return
        }
        response.forEach(r => {
          temp.push({
            x: r.formated_date,
            y: r.battery
          })
        })
        this.datacollection.datasets[0] = {
          label: 'DATA',
          data: temp,
          fill: false,
          backgroundColor: 'white',
          borderColor: 'red',
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 1
        }

        if(temp[0].x.split(' ')[1].split(':')[0] - temp[temp.length - 1].x.split(' ')[1].split(':')[0] < 12) {
          this.chartOps.scales.xAxes[0].time.stepSize = 1
        } else {
          this.chartOps.scales.xAxes[0].time.stepSize = 2
        }
        this.chartOps.scales.xAxes[0].time.min = temp[temp.length - 1].x
        this.chartOps.scales.xAxes[0].time.max = temp[0].x
        this.chartOps.scales.yAxes[0].ticks.min = Math.min.apply(Math, temp.map(o => o.y)) - 1
        this.chartOps.scales.yAxes[0].ticks.max = Math.max.apply(Math, temp.map(o => o.y)) + 1
        this.$refs.chart[id]._chart.update(0)
      })
      .catch(err => {
        console.log('Err', err)
      })
    },
    toggleTD(r, id) {
      $(`#${r}`).toggleClass('hidden')
      if(this.datacollection.datasets[0]){
        this.datacollection.datasets[0].data = ''
        this.$refs.chart[id]._chart.update(0)
      }
    },
    loading() {
      document.querySelector('#loading-btnData').click()
    },
    imgUrl(url) {
      return require('imgs/' + url)
    }
  },
  watch: {
    data() {
      this.data.forEach((d, i) => {
        this.data[i].bitArr = {
         cd : { name: 'Cálculo deshabilitado', val: d.calculo || 0 },
         gps: { name: 'Error GPS', val: d.gps || 0 },
         puerto: { name: 'Error Puerto S', val: d.puerto || 0 },
         buf: { name: 'Bufereando', val: d.buf || 0 },
         grab: { name: 'Grabando', val: d.grab || 0 },
         fuga: { name: 'Evento de Fuga', val: d.leak || 0 },
         puerta_gabinete: { name: 'Puerta abierta de gabinete', val: d.buf || 0 },
         puerta_sensor: { name: 'Puerta abierta de sensor', val: d.sen || 0 },
        }
        setTimeout(() => {
          let percent = 0
          if(d.bateria >= 10) {
            percent = (((d.bateria - 10) + 1) / 6) * 100
          } else {
            percent = 1
          }

          document.querySelector(`#${d.estacion}${i}Bar`).style.width = `${percent}%`
          document.querySelector(`#${d.estacion}${i}Ubs`).style.width = `${percent}%`
        }, 500)
      })
    }
  },
  components: {
    LineChart,
    selectC,
    Modal,
    LoadingModal,
  },
  mounted() {
    for (var i in this.names) {
      if (this.names.hasOwnProperty(i)) {
        this.colspan++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.row {
  margin: 0;
  padding: 0;
}

.bar {
  height: 6px;
  border-radius: 25px;
  width: 100%;
  background-color: (--loading-color);
}

.indicator {
  width: 102% !important;
  margin-left: -1%;
}

table,
.panel-body {
  background-color: $bg;
  overflow: scroll;
  padding: 0;
}

.panel-default {
  background-color: $gray;
  border: none;
  border-radius: 0;
}

.table {
  thead {
    tr {
      th {
        color: white;
        background-color: $amarilloC;
      }
    }
  }
  th {
    text-align: left;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  tbody {
    tr {
      td {
        background-color: transparent !important;
        max-width: 700px;
        img {
          width: 100%;
        }
        .span_switch {
          width: 40px;
          height: 15px;
        }
        .green {
          background-color: green;
        }
        .red {
          background-color:red;
        }
        p {
          font-size: 12px;
        }
        i {
          color: $inactive;
          cursor: pointer;
          &:hover {
            color: $amarilloC;
          }
        }
      }
    }
  }
  .table-name {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding-right: -15px;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

.striped {
  &:nth-child(odd) {
    background-color: $bg !important;
  }

  &:nth-child(even) {
    background-color: white !important;
  }
}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// DropDownTable.vue?67006290